import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './HpRespPromoModulePromoItem.scss';

function HpRespPromoModulePromoItem({ promotion, className, onClick }) {
    const { mobileImageUrl, imageUrl, link } = promotion;

    const itemClassNames = classnames(styles.item, className);

    const shownImageUrl = imageUrl || mobileImageUrl;

    return (
        <div className={itemClassNames}>
            <a href={link} className={styles.link} onClick={onClick}>
                <img className={styles.image} src={shownImageUrl} />
            </a>
        </div>
    );
}

HpRespPromoModulePromoItem.propTypes = {
    promotion: PropTypes.shape({
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        link: PropTypes.string,
        imageHeight: PropTypes.string,
        alignment: PropTypes.string,
    }).isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

HpRespPromoModulePromoItem.defaultProps = {
    onClick: () => {},
};

export { HpRespPromoModulePromoItem };
